export const themeCss = `
  :root {
    --aura-navy-800: #071948;
    --aura-navy-700: #36456b;
    --aura-navy-600: #515e7f;
    --aura-navy-500: #838ca3;
    --aura-navy-400: #b5bac8;
    --aura-navy-300: #e6e8ed;
    --aura-navy-200: #f3f4f6;
    --aura-navy-100: #f8f8fa;
    --aura-blue-700: #2c25a5;
    --aura-blue-600: #4036ed;
    --aura-blue-400: #7972f2;
    --aura-blue-200: #b2aef7;
    --aura-blue-100: #ebeafd;
    --aura-coral-700: #b24748;
    --aura-coral-600: #ff6668;
    --aura-coral-400: #ff9395;
    --aura-coral-200: #ffc1c2;
    --aura-coral-100: #ffefef;
    --aura-yellow-700: #b28e35;
    --aura-yellow-600: #ffcb4d;
    --aura-yellow-400: #ffda82;
    --aura-yellow-200: #ffeab7;
    --aura-yellow-100: #fff9ed;
    --aura-teal-700: #0b8a90;
    --aura-teal-600: #11c6cf;
    --aura-teal-400: #58d7dd;
    --aura-teal-200: #9fe8eb;
    --aura-teal-100: #e7f9fa;
    --aura-white: #ffffff;
  }
  *,
  pre {
    font-family: Treatwell Sans;
    font-style: normal;
  }
  .aura--h1,
  .aura--h2,
  .aura--h3,
  .aura--h3-constant,
  .aura--h4,
  .aura--h5,
  .aura--h5-constant,
  .aura--h6,
  .aura--h6-constant {
    color: var(--aura-navy-800);
  }
  .aura--link {
    color: var(--aura-blue-600);
    & path {
      fill: var(--aura-blue-600);
    }
    &:hover {
      color: var(--aura-blue-400);
      & path {
        fill: var(--aura-blue-400);
      }
    }
    &:active {
      color: var(--aura-blue-700);
      & path {
        fill: var(--aura-blue-700);
      }
    }
  }
  .aura--link-disruptive {
    color: var(--aura-coral-600);
    & path {
      fill: var(--aura-coral-600);
    }
    &:hover {
      color: var(--aura-coral-400);
      & path {
        fill: var(--aura-coral-400);
      }
    }
    &:active {
      color: var(--aura-coral-700);
      & path {
        fill: var(--aura-coral-700);
      }
    }
  }
  .aura--link-disabled {
    color: var(--aura-navy-400);
    & path {
      fill: var(--aura-navy-400);
    }
    &:hover {
      color: var(--aura-navy-400);
      & path {
        fill: var(--aura-navy-400);
      }
    }
    &:active {
      color: var(--aura-navy-400);
      & path {
        fill: var(--aura-navy-400);
      }
    }
  }
  .aura--label {
    background-color: var(--aura-teal-100);
    color: var(--aura-teal-700);
  }
  .aura--card {
    border: 1px solid var(--aura-navy-300);
    background-color: var(--aura-white);
    border-radius: 8px;
    &:hover {
      border: 1px solid var(--aura-blue-600);
      box-shadow: 0 2px 10px var(--aura-navy-300);
    }
    &:active {
      border: 1px solid var(--aura-blue-600);
      box-shadow: 0 2px 10px var(--aura-navy-300);
    }
    &:focus {
      border: 1px solid var(--aura-blue-600);
      box-shadow: 0 2px 10px var(--aura-navy-300);
    }
  }
  .aura--button-primary {
    background-color: var(--aura-blue-600);
    color: var(--aura-white);
    fill: var(--aura-white);
    &.aura--button-disruptive {
      background-color: var(--aura-coral-600);
    }
    &:disabled {
      background-color: var(--aura-navy-300) !important;
      color: var(--aura-navy-400) !important;
      fill: var(--aura-navy-400) !important;
      cursor: not-allowed !important;
    }
    &:hover {
      background-color: var(--aura-blue-400);
      &.aura--button-disruptive {
        background-color: var(--aura-coral-400);
      }
    }
    &:active {
      background-color: var(--aura-blue-700);
      &.aura--button-disruptive {
        background-color: var(--aura-coral-700);
      }
    }
  }
  .aura--button-secondary {
    color: var(--aura-blue-600);
    fill: var(--aura-blue-600);
    border: 1px solid var(--aura-navy-400);
    &.aura--button-disruptive {
      color: var(--aura-coral-600);
      fill: var(--aura-coral-600);
    }
    &:disabled {
      background-color: var(--aura-navy-300) !important;
      color: var(--aura-navy-400) !important;
      fill: var(--aura-navy-400) !important;
    }
    &:hover {
      background-color: var(--aura-blue-100);
      border: 1px solid var(--aura-blue-100);
      &.aura--button-disruptive {
        background-color: var(--aura-coral-100);
        border: 1px solid var(--aura-coral-100);
      }
    }
    &:active {
      background-color: var(--aura-blue-100);
      color: var(--aura-blue-700);
      fill: var(--aura-blue-700);
      border: 1px solid var(--aura-blue-100);
      &.aura--button-disruptive {
        background-color: var(--aura-coral-100);
        color: var(--aura-coral-700);
        fill: var(--aura-coral-700);
        border: 1px solid var(--aura-coral-100);
      }
    }
  }
  .aura--button-tertiary {
    color: var(--aura-blue-600);
    fill: var(--aura-blue-600);
    border: none;
    &.aura--button-disruptive {
      color: var(--aura-coral-600);
      fill: var(--aura-coral-600);
    }
    &:disabled {
      color: var(--aura-navy-400) !important;
      fill: var(--aura-navy-400) !important;
    }
    &:hover {
      color: var(--aura-blue-400);
      fill: var(--aura-blue-400);
      &.aura--button-disruptive {
        color: var(--aura-coral-400);
        fill: var(--aura-coral-400);
      }
    }
    &:active {
      color: var(--aura-blue-700);
      fill: var(--aura-blue-700);
      &.aura--button-disruptive {
        color: var(--aura-coral-700);
        fill: var(--aura-coral-700);
      }
    }
  }
  .aura--checkbox {
    color: var(--aura-blue-600);
    .aura--checkbox-empty {
      border-color: var(--aura-navy-400);
    }
    .aura--checkbox-checked {
      svg {
        path {
          fill: var(--aura-white);
        }
      }
    }
    &.checked {
      div {
        background-color: var(--aura-blue-600);
      }
    }
    &.read-only {
      div {
        background-color: var(--aura-navy-400);
      }
    }
    &.disabled {
      .aura--checkbox-empty {
        border: solid 1px var(--aura-navy-300);
      }
      div {
        background-color: var(--aura-navy-300);
      }
    }
  }
  .aura--flash-message {
    border: 1px solid var(--aura-navy-400);
    background-color: var(--aura-navy-200);
    color: var(--aura-navy-800);
    &.aura--flash-message-default {
      border-color: var(--aura-navy-400);
      background-color: var(--aura-navy-200);
      .aura--flash-message-icon path,
      .aura--flash-message-icon polygon {
        fill: var(--aura-navy-800);
      }
    }
    &.aura--flash-message-success {
      border-color: var(--aura-teal-600);
      background-color: var(--aura-teal-100);
      .aura--flash-message-icon path,
      .aura--flash-message-icon polygon {
        fill: var(--aura-teal-600);
      }
    }
    &.aura--flash-message-error {
      border-color: var(--aura-coral-600);
      background-color: var(--aura-coral-100);
      .aura--flash-message-icon path,
      .aura--flash-message-icon polygon {
        fill: var(--aura-coral-600);
      }
    }
    &.aura--flash-message-warning {
      border-color: var(--aura-yellow-700);
      background-color: var(--aura-yellow-100);
      .aura--flash-message-icon path,
      .aura--flash-message-icon polygon {
        fill: var(--aura-yellow-700);
      }
    }
    .aura--flash-message-close-button path,
    .aura--flash-message-close-button polygon {
      fill: var(--aura-navy-800);
    }
  }
  .aura--input {
    border: none;
    border-radius: 8px;
    color: var(--aura-navy-800);
  }
  .aura--input-fieldset {
    border: 1px solid var(--aura-navy-400);
    border-radius: 8px;
    background-color: transparent;
  }
  .aura--input-label {
    color: var(--aura-navy-500);
  }
  .aura--input-container:focus-within {
    .aura--input-fieldset {
      border-color: var(--aura-blue-600);
    }
    &:not(.has-error) .aura--input-label {
      color: var(--aura-blue-600);
    }
  }
  .aura--input-container.has-error {
    .aura--input-fieldset {
      border-color: var(--aura-coral-600);
    }
  }
  .aura--input-inner-left-component-wrapper path {
    fill: var(--aura-navy-500);
  }
  .aura--error-label {
    color: var(--aura-coral-600);
  }
  .aura--success-label {
    color: var(--aura-teal-600);
  }
  .aura--select-input,
  .aura--select-option {
    background-color: var(--aura-white);
  }
  .aura--select-option:hover,
  .aura--select-option-active {
    background-color: var(--aura-navy-100);
  }
  .aura--select-option-selected {
    background-color: var(--aura-navy-200);
    &:hover,
    &.aura--select-option-active {
      background-color: var(--aura-navy-200);
    }
  }
  .aura--select-options-container {
    box-shadow: 0 2px 10px 0 var(--aura-navy-300);
  }
  .aura--otp-input {
    :focus {
      background-color: var(--aura-navy-200);
      border: 1px solid var(--aura-navy-500);
    }
    border: 1px solid var(--aura-navy-400);
  }
`;
